import React from "react";
import { Snackbar, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

export type ToastType = "success" | "error";

interface ReusableToastProps {
  isOpen: boolean;
  type: ToastType;
  message: string;
  onClose: () => void;
}

const ReusableToast: React.FC<ReusableToastProps> = ({ isOpen, type, message, onClose }) => {
  const icon =
    type === "success" ? (
      <CheckCircleIcon
        sx={{
          fill: "#2e7d32",
        }}
      />
    ) : (
      <ErrorIcon
        sx={{
          fill: "#5F1C15",
        }}
      />
    );
  const color = type === "success" ? "#2e7d32" : "#F71600";

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ mt: 1, mr: 1 }}
    >
      <Alert
        onClose={onClose}
        // severity={color}
        icon={icon}
        variant="filled"
        sx={{
          backgroundColor: "#1E1E1E",
          border: `solid 0.5px ${color}!important`,
          color: "#fff",
          borderRadius: "8px",
          boxShadow: "none",
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          fontWeight: 500,
          fontSize: "0.875rem",
          lineHeight: 1.43,
          letterSpacing: "0.01071em",
          display: "flex",
          alignItems: "start",
          padding: "6px 16px",
          transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          maxWidth: "80%",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ReusableToast;
